import { put, call, take } from 'redux-saga/effects';
import {
  setInitialLiveData,
  setLiveData,
} from '../../../actions/domain/centrifugo/liveData';
import {
  CENTRIFUGO_LISTENED_EVENTS,
  ENDING_EVENTS,
} from '../../../constants/centrifugo';
import { PROJECTS } from '../../../../constants/centrifugo';

/**
 * @param {Array<any>} initialState
 * @returns {Generator<*, void, *>}
 */
export function* liveDataInitializer(initialState) {
  const liveData = initialState.reduce((acc, { gameId, ...data }) => {
    acc[gameId] = data;
    return acc;
  }, {});
  yield put(setInitialLiveData(liveData));
}

export function* liveDataConnectorWatcher() {
  while (true) {
    const { type, payload } = yield take(CENTRIFUGO_LISTENED_EVENTS);
    const liveData = payload && payload?.data?.[PROJECTS.LIVE_DATA];

    if (ENDING_EVENTS.includes(type) || !liveData) {
      return;
    }

    yield call(liveDataInitializer, liveData['initial-state']);
  }
}

export function* liveDataHandler(data) {
  yield put(setLiveData(data));
}
